module.exports = __webpack_public_path__ + "assets/close.svg?cb3314fab92e95d3b42d24c69597de52";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 1068
// module chunks = 0